import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../../LoadingSpinner";
import ReactModal from "react-modal";
import { defaultModalStyles } from "../../../common/CustomModalStyles";
import DeleteSignatureModal from "./DeleteSignatureModal";
import { useTeamsQuery } from "../../../../Services/settingsAPIs/CommonAPI";
import AddSignatureModal from "./AddSignatureModal";
import EditSignatureModal from "./EditSignatureModal";
import {
  useSmtpMailConfigsSignatureQuery,
  useGetSignatureQuery,
} from "../../../../Services/settingsAPIs/SignatureApi";

const SignatureTemplate = () => {
  const [signatures, setSignatures] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedSignature, setSelectedSignature] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [signatureToDelete, setSignatureToDelete] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<"default" | "users" | "live">(
    "default"
  );
  const [theTeams, setTheTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState<number>(0);

  const { data: emailIMAPmailConfigData } =
    useSmtpMailConfigsSignatureQuery(selectedTeam);
  const emailIMAPmailConfigID = emailIMAPmailConfigData?.[0]?.id;

  const { data, isLoading, refetch } = useGetSignatureQuery(
    { selectedTeam },
    { skip: !selectedTeam }
  );
  const { data: teamsData } = useTeamsQuery({});

  // Get current logged-in user ID from localStorage
  const currentUserId = Number(localStorage.getItem("User_Id"));

  console.log(selectedTeam, "selectedTeam");

  useEffect(() => {
    if (data?.results) {
      setSignatures(data.results);
    }
  }, [data]);

  useEffect(() => {
    if (teamsData) setTheTeams(teamsData);
  }, [teamsData]);

  const handleSelectTeamChange = (event: any) => {
    setSelectedTeam(Number.parseInt(event.target.value));
  };

  const openAddModal = () => {
    setAddModalOpen(true);
  };

  const closeAddModal = () => {
    setAddModalOpen(false);
  };

  const openEditModal = (signature) => {
    setSelectedSignature(signature);
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
    setSelectedSignature(null);
  };

  const openDeleteModal = (signature) => {
    setSignatureToDelete(signature);
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
    setSignatureToDelete(null);
  };

  const refetchingData = async () => {
    await refetch();
  };

  const onSaveSuccess = async () => {
    await refetchingData();
  };

  // Get default signature: is_default === true OR (is_default === false && user === null)
  // This handles both explicit default signatures and unassigned signatures
  const defaultSignature = signatures.find(
    (sig: any) =>
      sig.is_default === true || (sig.is_default === false && sig.user === null)
  );

  // Get individual user signatures: is_default === false AND user !== null
  const userSignatures = signatures.filter(
    (sig: any) => sig.is_default === false && sig.user !== null
  );

  // Get user-specific signature for current logged-in user
  const userSpecificSignature = signatures.find(
    (sig: any) => sig.is_default === false && sig.user === currentUserId
  );

  // Live signature logic (same logic as Compose component):
  // If default signature has is_default === true, use it (applies to all users)
  // If default signature has is_default === false, use user-specific signature instead
  const isDefaultActive = signatures.some(
    (sig: any) => sig.is_default === true
  );
  const liveSignature = isDefaultActive
    ? defaultSignature
    : userSpecificSignature;

  if (isLoading)
    return (
      <div className="text-center mt-4">
        <LoadingSpinner />
      </div>
    );

  return (
    <div className="container-fluid" style={{ marginLeft: "2%", marginRight: "2%", width: "96%" }}>
      {/* Header with Team Dropdown and Add Button */}
      {activeTab !== "live" && (
        <div className="row mt-2" style={{ marginBottom: "-42px" }}>
          <div className="col">
            <button
              className="input-group-text align-items-center text-hover-primary fw-bold float-end"
              disabled={!selectedTeam}
              onClick={openAddModal}
            >
              <i className="bi bi-plus-lg me-2"></i>
              Add
            </button>
          </div>
        </div>
      )}

      <div className="row mt-2">
        <div className="col-2">
          <label>Select team</label>
          <select
            className="form-select select2-hidden-accessible"
            onChange={handleSelectTeamChange}
            value={selectedTeam}
          >
            <option value={0}>Select team</option>
            {theTeams?.map((el: any) => (
              <option value={el?.id} key={el?.id}>
                {el?.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Page Title */}
      <div className="row mt-2">
        <div className="col">
          <span className="input-group-text mt-2">Signature template</span>
        </div>
      </div>

      {/* Tabs - Only show when team is selected */}
      {selectedTeam > 0 && (
        <>
          <div className="row mt-3">
            <div className="col">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "default" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("default")}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-star-fill text-warning me-2"></i>
                    Default signature
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "users" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("users")}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-people-fill me-2"></i>
                    User signatures
                    {userSignatures.length > 0 && (
                      <span className="badge bg-primary ms-2">
                        {userSignatures.length}
                      </span>
                    )}
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "live" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("live")}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-broadcast text-success me-2"></i>
                    Live signature
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Tab Content - Only show when team is selected */}
          <div className="row mt-3">
            <div className="col">
              {/* Default Signature Tab */}
              {activeTab === "default" && (
                <div className="tab-content-section">
                  {defaultSignature ? (
                    <div
                      className="d-flex align-items-center border border-secondary border-2 rounded-2 p-3"
                      style={{
                        boxShadow: "0 1px 1px -1px grey, 0 1px 1px 0 grey",
                      }}
                    >
                      <div className="flex-grow-1">
                        <h5 className="mb-1 fw-bold">
                          {defaultSignature.name}
                        </h5>
                        <small className="text-muted">
                          <i className="bi bi-info-circle me-1"></i>
                          Applied to all team members by default
                        </small>
                      </div>

                      <div className="ms-auto d-flex gap-2">
                        <button
                          className="btn btn-link text-hover-info"
                          onClick={() => openEditModal(defaultSignature)}
                          title="Edit Default Signature"
                        >
                          <i className="bi bi-pencil fs-2"></i>
                        </button>
                        <button
                          className="btn btn-link text-hover-danger"
                          onClick={() => openDeleteModal(defaultSignature)}
                          title="Delete Default Signature"
                        >
                          <i className="bi bi-trash fs-2 mx-2"></i>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center mt-5 py-5">
                      <i className="bi bi-inbox fs-1 text-muted opacity-50"></i>
                      <h5 className="text-muted mt-3">
                        No default signature found
                      </h5>
                      <p className="text-muted small">
                        Create a default signature that will be used by all team
                        members
                      </p>
                      <button
                        className="btn btn-primary mt-2"
                        onClick={openAddModal}
                      >
                        <i className="bi bi-plus-lg me-2"></i>
                        Create default signature
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* User Signatures Tab */}
              {activeTab === "users" && (
                <div className="tab-content-section">
                  {userSignatures.length > 0 ? (
                    <>
                      {userSignatures.map((signature) => (
                        <div
                          key={signature.id}
                          className="d-flex align-items-center border border-secondary border-2 rounded-2 mt-2 p-3"
                          style={{
                            boxShadow: "0 1px 1px -1px grey, 0 1px 1px 0 grey",
                          }}
                        >
                          <div className="flex-grow-1">
                            <h5 className="mb-1 fw-bold">{signature.name}</h5>
                            <small className="text-muted">
                              <i className="bi bi-person-check-fill me-1"></i>
                              Individual user signature
                            </small>
                          </div>

                          <div className="ms-auto d-flex gap-2">
                            <button
                              className="btn btn-link text-hover-info"
                              onClick={() => openEditModal(signature)}
                              title="Edit user signature"
                            >
                              <i className="bi bi-pencil fs-2"></i>
                            </button>
                            <button
                              className="btn btn-link text-hover-danger"
                              onClick={() => openDeleteModal(signature)}
                              title="Delete user signature"
                            >
                              <i className="bi bi-trash fs-2 mx-2"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="text-center mt-5 py-5">
                      <i className="bi bi-person-x fs-1 text-muted opacity-50"></i>
                      <h5 className="text-muted mt-3">
                        No user signatures found
                      </h5>
                      <p className="text-muted small">
                        Individual signatures override the default team
                        signature
                      </p>
                      <button
                        className="btn btn-success mt-2"
                        onClick={openAddModal}
                      >
                        <i className="bi bi-plus-lg me-2"></i>
                        Create user signature
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* Live Signature Tab */}
              {activeTab === "live" && (
                <div className="tab-content-section">
                  {liveSignature ? (
                    <div
                      className="border border-secondary border-2 rounded-2 p-3"
                      style={{
                        boxShadow: "0 1px 1px -1px grey, 0 1px 1px 0 grey",
                      }}
                    >
                      <div className="d-flex align-items-center mb-3">
                        <div className="flex-grow-1">
                          <h5 className="mb-1 fw-bold">{liveSignature.name}</h5>
                          <small className="text-muted">
                            <i className="bi bi-info-circle me-1"></i>
                            {isDefaultActive
                              ? "Applied to all team members by default"
                              : "Applied to your emails (personal signature)"}
                          </small>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center mt-5 py-5">
                      <i className="bi bi-inbox fs-1 text-muted opacity-50"></i>
                      <h5 className="text-muted mt-3">
                        No active signature found
                      </h5>
                      <p className="text-muted small">
                        Create a default signature or a personal user signature
                      </p>
                      <button
                        className="btn btn-primary mt-2"
                        onClick={() => setActiveTab("default")}
                      >
                        <i className="bi bi-plus-lg me-2"></i>
                        Create default signature
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* Add Signature Modal - Pass activeTab */}
      <AddSignatureModal
        isOpen={addModalOpen}
        closeModal={closeAddModal}
        onSaveSuccess={onSaveSuccess}
        selectedTeam={selectedTeam}
        emailIMAPmailConfigID={emailIMAPmailConfigID}
        existingSignatures={signatures}
        activeTab={activeTab}
      />

      {/* Edit Signature Modal */}
      <EditSignatureModal
        isOpen={editModalOpen}
        closeModal={closeEditModal}
        signatureData={selectedSignature}
        onSaveSuccess={onSaveSuccess}
        selectedTeam={selectedTeam}
        emailIMAPmailConfigID={emailIMAPmailConfigID}
      />

      {/* Delete Signature Modal */}
      <ReactModal
        isOpen={deleteModalOpen}
        style={defaultModalStyles}
        contentLabel="Delete a signature"
        shouldCloseOnOverlayClick={false}
      >
        <DeleteSignatureModal
          closeModal={closeDeleteModal}
          signatureToDelete={signatureToDelete}
          setSignatures={setSignatures}
          signatures={signatures}
          refetchingData={refetchingData}
        />
      </ReactModal>

      <style>{`
        .nav-tabs {
          border-bottom: 2px solid #dee2e6;
        }
        
        .nav-tabs .nav-link {
          border: none;
          color: #6c757d;
          font-weight: 500;
          padding: 12px 20px;
          background: transparent;
          border-bottom: 3px solid transparent;
          transition: all 0.2s;
        }
        
        .nav-tabs .nav-link:hover {
          color: #495057;
          border-color: transparent;
          background-color: #f8f9fa;
        }
        
        .nav-tabs .nav-link.active {
          color: #6366f1;
          background-color: transparent;
          border-bottom: 3px solid #6366f1;
          font-weight: 600;
        }
        
        .tab-content-section {
          min-height: 300px;
        }
        
        .badge {
          font-size: 0.75rem;
          padding: 0.25rem 0.5rem;
        }
      `}</style>
    </div>
  );
};

export default SignatureTemplate;
